import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { DashboardService } from './dashboard.service';
import { fuseAnimations } from '../../../core/animations';
import { ActivatedRoute, Router } from '@angular/router';

import { User } from '../../../core/modelos/user';
import { Activo } from '../../../core/modelos/activo';
import { FileManagerService } from '../file-manager/file-manager.service';
import { Fichero } from '../../../core/modelos/fichero';
import { Ticket } from '../../../core/modelos/ticket';
import { TicketsService } from '../tickets/tickets.service';
import { NotificacionesService } from '../../../core/notificaciones/notificaciones.service';

import { ActivosService } from '../../content/activos/activos.service';
/*
// import AWS object without services
import AWS = require('aws-sdk/global');
*/
// import individual service
// import S3 = require('aws-sdk/clients/s3');

@Component({
    selector: 'fuse-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations
})
export class FuseDashboardComponent implements OnInit, OnDestroy {
    // Usuario conectado
    usuarioLogueado: User;

    activo: Activo;
    idActivo: number;

    ficheros: Array<Fichero>;

    grafico: any = {};

    dateNow = Date.now();
    foto;
    tickets: Array<Ticket>;
    ticketChart: Array<{
        name: string,
        value: number
    }>;
    luzVerdeChart = false;

    tabElegida = '';

    // @ViewChild(MatTabGroup) tabs: MatTabGroup;

    url = '';
    marcadores: any;
    indexPopup: number;

    constructor(
        private dashboardService: DashboardService,
        private activatedRoute: ActivatedRoute,
        private fileManagerService: FileManagerService,
        private ticketService: TicketsService,
        private activosService: ActivosService,
        private notificaciones: NotificacionesService,
        private router: Router
    ) {

        this.grafico = {
            currentRange: 'TW',
            legend: false,
            explodeSlices: false,
            labels: true,
            doughnut: true,
            gradient: false,
            scheme: {
                domain: ['#f44336', '#03a9f4', '#e91e63']
            },
            onSelect: (ev) => {
                console.log(ev);
            }
        };

        setInterval(() => {
            this.dateNow = Date.now();
        }, 1000);
        this.usuarioLogueado = JSON.parse(sessionStorage.getItem('usuarioLogueado')).usuario;
    }

    ngOnInit() {
        // Traigo el activo por parametro
        this.activatedRoute.params.subscribe(params => {
            this.idActivo = params['activoSeleccionado'];
            localStorage.setItem('activoSeleccionadoId', String(this.idActivo));
            this.getActivo();

            // notify about the new activo
            this.activosService.setCurrentActivo(this.idActivo)
        });
    }

    onMarcadores(event: any) {
        this.marcadores = event;
    }

    onIndexPopup(event: any) {
        this.indexPopup = event;
    }

    getActivo() {
        this.dashboardService.getActivo(this.idActivo).subscribe(
            data => {
                if (data.success) {
                    this.activo = data.items;

                    this.activosService.getActivoImagen(this.activo.id).subscribe(data => {
                      this.activo.imagen = data.items ? 'data:image/jpeg;base64,' + data.items : null;
                    });
                    // this.foto = this.activo.imagen;
                    // this.url += this.activo.enlace;

                    // this.getTicketsActivo();
                    // this.mostrarFicherosDeActivo();

                    /* if (this.usuarioLogueado.rol.id !== 1) {
                        // Para llamar al metodo de los ficheros, ahora tengo que tener el activo y traerme solo sus documentos
                        // Por eso lo llamo una vez que tengo this.activo
                    } */
                } else {
                    // CONTROLAR ERROR
                    this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Activos.ActivoNOObtenido);
                }
            },
            err => {
                // CONTROLAR ERROR
                this.notificaciones.errorServidor(err.status);
            }
        );
    }
    mostrarFicherosDeActivo() {
        const component = this;
        this.fileManagerService.getFilesDeActivo(this.activo).send(function (err, data) {
            if (!err) {
                let ficheros = FileManagerService.categorizarFicheros(data);
                if (ficheros.length === 0) {
                    ficheros = [];
                }
                component.generarRama(ficheros);
            }
        });

        // ESTE SERA EL METODO DEFINITIVO PORQUE SOLO QUEREMOS LOS ARCHIVOS QUE CORRESPONDAN AL ACTIVO QUE ESTA CONSULTANDO

        /* this.fileManagerService.getFilesDeActivo(this.activo).send(function (err, data) {
            if (!err) {
                let ficheros = FileManagerService.categorizarFicheros(data);
                if (ficheros.length === 0) {
                    ficheros = [];
                }
                component.generarRama(ficheros);
            }
        }); */

    }
    generarRama(ficherosListados: Fichero[]) {
        this.ficheros = [];

        ficherosListados.forEach(objeto => {

            const partes = objeto.key.split('/');
            // Guardo solo los archivos, no las carpetas
            if (objeto.type !== 'folder') {
                objeto.name = partes[partes.length - 1];
                if (objeto.name !== '') {
                    this.ficheros.push(objeto);
                }
            }
        });
        // Ordeno por fecha de modificacion
        this.ficheros.sort((a, b) => {
            return new Date(b.lastmodified).getTime() - new Date(a.lastmodified).getTime();
        });
    }
    descargarFichero(fichero: Fichero) {
        this.fileManagerService.descargarFichero(fichero.key);
    }
    detalleTicket(ticket: Ticket) {
        this.router.navigate(['/tickets/editar/', ticket.id]);
    }

    getTicketsActivo() {
        this.ticketService.getTicketFromActivo(this.activo.id).subscribe(
            data => {
                if (data.success) {
                    this.tickets = data.items;
                    // Como no tienen fecha, vienen ordenados por id de menor a mayor. Los recientes son ids mayores, asi que cambio el orden
                    this.tickets.reverse();
                    // Ahora voy a tratar los tickets para mostrar el grafico correctamente
                    this.luzVerdeChart = false;
                    const abiertas = {
                        'name': 'Abiertas',
                        'value': 0
                    };
                    const procesando = {
                        'name': 'En proceso',
                        'value': 0
                    };
                    const cerradas = {
                        'name': 'Cerradas',
                        'value': 0
                    };
                    this.tickets.forEach(ticket => {
                        switch (ticket.estado) {
                            case 'abierta':
                                abiertas.value++;
                                this.luzVerdeChart = true;
                                break;
                            case 'procesando':
                                procesando.value++;
                                this.luzVerdeChart = true;
                                break;
                            case 'cerrada':
                                cerradas.value++;
                                this.luzVerdeChart = true;
                                break;
                        }
                    });
                    this.ticketChart = [];
                    this.ticketChart.push(abiertas, procesando, cerradas);

                    // Hago seguimiento de la tab seleccionada
                    // this.actualizarTabElegida(this.tabs.selectedIndex);
                    // this.tabs.selectedIndexChange.subscribe(index => this.actualizarTabElegida(index));

                } else {
                    this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Tickets.SinTicketsDeActivo);
                    // CONTROLAR ERROR
                }
            },
            err => {
                // CONTROLAR ERROR
                this.notificaciones.errorServidor(err.status);
            }
        );
    }

    goTickets() {
        this.router.navigate(['/tickets', this.idActivo]);
    }

    actualizarTabElegida(index: number) {

        switch (index) {
            case 0: this.tabElegida = 'docs';
                break;
            case 1: this.tabElegida = 'tickets';
                break;
            default: this.tabElegida = '';
                break;
        }

    }

    ngOnDestroy() {
    }

    goDocument(fichero) {
        setTimeout(() => {
            this.fileManagerService.setFicheroDashboard(fichero);
        });
        this.router.navigate(['/docs/buscar']);
    }

    goToDocs() {
        if (this.activo.carpetaAWS) {
            this.router.navigate(['/docs']);
            this.fileManagerService.setCarpetaDestino(this.activo.carpetaAWS);
        }
        else {
            // Mostrar error
            alert('El activo no tiene carpeta asociada');
        }

    }

    go3dViewer() {
        // this.router.navigate(['/3d-viewer', this.url]);
        this.router.navigate(['/3d-viewer', { enlace: this.url, id: this.idActivo }], { skipLocationChange: true });

    }

    goPowerBi(url: string, descripcion: string) {
        // this.router.navigate(['/power-bi', url]);
        this.router.navigate(['/power-bi', url, descripcion], { skipLocationChange: true });

    }

}



// WEBPACK FOOTER //
// ./src/app/main/content/dashboard/dashboard.component.ts